import {fromEntries, keys} from '../util';
import {ZodRawShape, ZodType, ZodObject} from 'zod';

export function isZodType<T>(zodType: ZodType<T>, obj: unknown): obj is T {
  return zodType.safeParse(obj).success;
}

export function zodTypeguard<T>(zodType: ZodType<T>) {
  return (obj: unknown): obj is T => isZodType(zodType, obj);
}

export function projectionFromShape<T extends ZodObject<ZodRawShape>>(
  schema: T
) {
  return fromEntries(
    keys(schema.shape).map((k) => [k, 1] satisfies [string | number, 1])
  );
}
